<template>
    <div :class="{ 'search-field': true, 'search-field--active': value.length > 0 }">
        <input 
            type="text" 
            spellcheck="false" 
            :class="inputClass" 
            :placeholder="placeholder" 
            :name="name"
            v-model="value"
            @input="$emit('search', $event.target.value)" 
        />

        <button v-if="clearButton" class="search-field__clear" @click="value = ''; $emit('search', '');">
            <img :src="getIconSrc('cross.svg')" />
        </button>
    </div>
</template>

<script>
import NeedsIcons from '../Mixins/NeedsIcons';

export default {
    mixins: [ NeedsIcons ],
    props: {
        name: {
            type: String
        },
        placeholder: {
            type: String
        },
        inputClass: {
            type: String,
            default: 'form__input'
        },
        clearButton: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            value: ''
        };
    }
}
</script>